<template>
  <v-card hover :loading="!accountBalance" tile ref="project-info">
    <v-card-title>Mi cuenta</v-card-title>

    <v-list>
      <v-divider></v-divider>

      <v-list-item
        dark
        two-line
        ripple
        :style="{
          background: actualPlan == 'BÁSICO' ? '#df0209' : '#00C853'
        }"
      >
        <v-list-item-avatar>
          <v-img
            :src="actualPlan == 'BÁSICO' ? fontumiSad : fontumiHappy"
          ></v-img>
        </v-list-item-avatar>

        <v-list-item-content>
          <v-list-item-title>{{ actualPlan }}</v-list-item-title>
          <v-list-item-subtitle>Plan actual</v-list-item-subtitle>
        </v-list-item-content>
      </v-list-item>

      <v-divider></v-divider>

      <v-list-item two-line>
        <v-list-item-content>
          <v-list-item-title>{{
            accountBalance && accountBalance.creditBalance
              ? Math.floor(accountBalance.creditBalance / 16)
              : "-"
          }}</v-list-item-title>
          <v-list-item-subtitle
            >Minutos restantes en el mes</v-list-item-subtitle
          >
        </v-list-item-content>
      </v-list-item>
      <v-list-item two-line>
        <v-list-item-content>
          <v-list-item-title
            >${{
              accountBalance && accountBalance.creditBalance
                ? accountBalance.creditBalance
                : "-"
            }}
            COP</v-list-item-title
          >
          <v-list-item-subtitle>Saldo restante en el mes</v-list-item-subtitle>
        </v-list-item-content>
      </v-list-item>
      <v-list-item two-line>
        <v-list-item-content>
          <v-list-item-title>{{ project.sip.login }}</v-list-item-title>
          <v-list-item-subtitle>Usuario de cuenta SIP</v-list-item-subtitle>
        </v-list-item-content>
      </v-list-item>
    </v-list>
  </v-card>
</template>

<script>
import { mapActions, mapGetters } from "vuex";

import fontumiSad from "../../assets/fontumi-saaaaaaaaaaad.jpg";
import fontumiHappy from "../../assets/fontumi-happy.jpg";

export default {
  name: "ProjectInfo",

  data: () => ({
    fontumiSad,
    fontumiHappy
  }),

  computed: {
    actualPlan() {
      const accountBalance = this.accountBalance;
      if (
        accountBalance &&
        accountBalance.creditBalance &&
        accountBalance.creditBalance > 500
      ) {
        return "PREMIUM";
      }

      return "BÁSICO";
    },

    ...mapGetters({
      accountBalance: "getAccountBalance",
      project: "getProject",
      user: "getUser"
    })
  },

  methods: {
    ...mapActions(["seeAccountBalance"])
  },

  mounted() {
    this.seeAccountBalance();

    this.$emit("intro", {
      id: 0,
      name: "project-info",
      element: this.$refs["project-info"].$el,
      str: "Información de tu cuenta.",
      step: 0
    });
  }
};
</script>
